import { PlanHeader } from "./PlanHeader";

export class UnitOfMeasurement {
    public idUnit : string;
    public name : string;
    public symbol : string;
    public kSymbol : string;

    public planHeaders : Array<PlanHeader>;

    constructor(
        idUnit? : string,
        name? : string,
        symbol? : string,
        kSymbol? : string
    ){
        this.idUnit = idUnit;
        this.name = name;
        this.symbol = symbol;
        this.kSymbol = kSymbol;
    }
}